module.exports = __webpack_public_path__ + "static/media/custom-06.e4f0b229.jpg";